module.exports = __webpack_public_path__ + "img/growcify-website-4-banner.61a2bc08.png";